import type { LanguageCode } from '@/constants/languages';
import { resolveIntlLocale } from '@/utils/locale';

export function formatPercentage(value: number, languageCode?: LanguageCode): string {
  const locale = resolveIntlLocale(languageCode);

  return new Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}
